/**
 * Class that holds constants used in Flight Feature Names
 */
export class FeatureFlights {
  public static CDPTabVisibility: string = 'isCdpTabVisible';
  public static SkillsAndCapabilities: string = 'SkillsAndCapabilities';

  //Enabling this flight simulates the experience of a user whose role is not present in role library.
  //This flight is for TESTING only. Should never be enabled in production.
  public static NoRoleContent: string = 'NoRoleContent';
}
